
import Api from '@/utils/api';
import NotData from '../NoData/NoData.vue';
import MHeader from '../Header/Header.vue';
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

import {
setDefAddr,
delAddr,
getAddrList,
seset
} from '../../api';
export default {
components: {
MHeader,
Icon,
NotData
},
data() {
return {
list: [],
pathName: ""
}
},
methods: {
editorTab(item) {
this.$router.push({
name: 'AddAddress',
params: {
pathName: JSON.stringify(item)
}
})
},
addrIdTap(res) {
if ('takeWineDetail' == this.pathName) {
this.$store.commit('updateAddressDate', res);
this.$router.go(-1);
};
},
getAddrList() {
var that = this;


Api.getAddressList()
.then(res => {
this.list = res.data
console.log(res)
})









},
addressTap(item) {
this.$store.commit('showIsLoading');
setDefAddr(`addr_id=${item.addr_id}`).then(res => {
if (res.data.error_code) {
console.error('错误信息：' + res.data.msg);
return;
};
var list = this.list;
for (let i = 0; i < list.length; i++) {
list[i].def_addr = 0;
};
item.def_addr = 1;
});
},
setDefult(item) {
item.default = true
Api.updateAddress(item)
.then(res => {
_.forEach(this.list, (address) => {
if(item._id !== address._id){
address.default = false
}
})
})
},
delAddress(item, index) {
const _this = this 
this.$vux.confirm.show({

title: '提示',
content: '是否删除收获地址',
onConfirm() {
Api.delAddress(item._id)
.then(res => {
_this.$store.commit('updateToast', {
text: '地址删除成功',
show: true
});
_this.list.splice(index, 1);
});
}
})

}
},
computed: {
addressChang() {
return this.$store.state.addressChang;
}
},
watch: {
addressChang() {
this.getAddrList();
}
},
mounted() {
this.getAddrList();
},
beforeRouteEnter: (to, from, next) => {
next(vm => {
vm.pathName = from.name
});
}
}



// WEBPACK FOOTER //
// ./src/components/ShippingAddress/ShippingAddress.vue